import AssoManageListPage from '@/pages/ota/list'
import HotelDetailPage from '@/pages/ota/hotel-detail'
import RoomTypeDetail from '@/pages/ota/roomtype-detail'
import AssoManageListPageFeiZhu from '@/pages/ota/feizhu/list'
import HotelDetailPageFeiZhu from '@/pages/ota/feizhu/hotel-detail'
import RoomTypeDetailFeiZhu from '@/pages/ota/feizhu/roomtype-detail'
import AssoManageListPageTuJia from '@/pages/ota/tujia/list'
import HotelDetailPageTuJia from '@/pages/ota/tujia/hotel-detail/index'
import RoomTypeDetailTuJia from '@/pages/ota/tujia/roomtype-detail/index'

import ElongChannelListPage from '@/pages/ota/elong-list'
import ElongHotelDetailPage from '@/pages/ota/elong-hotel-detail'
import ElongRoomTypeDetail from '@/pages/ota/elong-roomtype-detail'

// OMS关联管理
export const assoManageList = {
  path: 'Ota/Ota/xbedChannelHotelList',
  component: AssoManageListPage
}

// OMS关联管理门店详情
export const hotelDetail = {
  path: 'Ota/Ota/xbedChannelHotelDetail',
  component: HotelDetailPage
}

// OMS关联管理房型详情
export const roomTypeDetail = {
  path: 'Ota/Ota/xbedChannelRoomTypeDetail',
  component: RoomTypeDetail
}

// OMS关联管理-飞猪
export const assoManageListFeiZhu = {
  path: 'Ota/Ota/feiZhu/channelHotelList',
  component: AssoManageListPageFeiZhu
}

// OMS关联管理门店详情-飞猪
export const hotelDetailFeiZhu = {
  path: 'Ota/Ota/feiZhu/channelHotelDetail',
  component: HotelDetailPageFeiZhu
}

// OMS关联管理房型详情-飞猪
export const roomTypeDetailFeiZhu = {
  path: 'Ota/Ota/feiZhu/channelRoomTypeDetail',
  component: RoomTypeDetailFeiZhu
}

// OMS关联管理-途家
export const assoManageListTuJia = {
  path: 'Ota/Ota/tujia/channelHotelList',
  component: AssoManageListPageTuJia
}

// OMS关联管理门店详情-途家
export const hotelDetailTuJia = {
  path: 'Ota/Ota/tujia/channelHotelDetail',
  component: HotelDetailPageTuJia
}

// OMS关联管理房型详情-途家
export const roomTypeDetailTuJia = {
  path: 'Ota/Ota/tujia/channelRoomTypeDetail',
  component: RoomTypeDetailTuJia
}
// OMS关联管理 - 艺龙
export const elongChannelList = {
  path: 'Ota/Ota/elongChannelHotelList',
  component: ElongChannelListPage

}
// OMS关联管理门店详情 - 艺龙
export const elongHotelDetail = {
  path: 'Ota/Ota/elongChannelHotelDetail',
  component: ElongHotelDetailPage
}

// OMS关联管理门店详情 - 艺龙
export const elongRoomTypeDetail = {
  path: 'Ota/Ota/elongChannelRoomTypeDetail',
  component: ElongRoomTypeDetail
}



// WEBPACK FOOTER //
// ./src/router/ota.js